import { combineEpics } from 'redux-observable';

import { getListProductDefaultEpic } from './getListProductDefault';
import { getListProductsEpic } from './getListProducts';
import { getProductsInfoEpic } from './getProductInfo';

const compareProductEpic = combineEpics(getListProductsEpic, getProductsInfoEpic, getListProductDefaultEpic);

export default compareProductEpic;
